import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { gatewayMessages } from 'src/features/gatewayPass/utils/messages.ts';
import { Badge } from 'src/registry/ui/Badge';
import { Translation } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';

type ZoneTranslationProps = {
    translations: Translation[];
    isEntry?: boolean;
};

const ZoneTranslation = ({ translations, isEntry }: ZoneTranslationProps) => {
    const { formatMessage, locale } = useIntl();

    const localeTranslation = translations.find((translation) => translation.language === locale);
    if (!localeTranslation)
        return (
            <Badge theme="gray">
                <FontAwesomeIcon icon={ICON_MAP.STATIC_SPINNER} />
                {formatMessage(gatewayMessages.outsideOfParking)}
            </Badge>
        );

    return (
        <Badge theme={isEntry ? 'green' : 'red'}>
            <FontAwesomeIcon icon={isEntry ? ICON_MAP.ARROW_RIGHT_ARC : ICON_MAP.ARROW_LEFT_FROM_ARC} />
            {localeTranslation?.name}
        </Badge>
    );
};

export default ZoneTranslation;
